import { config as danmakuConfig } from './modules/Danmaku/config';
import { config as groupInfoConfig } from './modules/GroupInfo/config';
import { config as groupTextConfig } from './modules/GroupText/config';
import { config as faqConfig } from './modules/FAQ/config';
import { config as bottomButtonConfig } from './modules/BottomButton/config';
import { config as singleImageConfig } from './modules/SingleImage/config';
import { config as richTextConfig } from './modules/RichText/config';
import { config as hotspotImageConfig } from './modules/HotspotImage/config';

export const MODULE_TYPES = {
    GROUP_TEXT: groupTextConfig,
    SINGLE_IMAGE: singleImageConfig,
    GROUP_INFO: groupInfoConfig,
    RICH_TEXT: richTextConfig,
    //FAQ: faqConfig,
    DANMAKU: danmakuConfig,
    BOTTOM_BUTTON: bottomButtonConfig,
    HOTSPOT_IMAGE: hotspotImageConfig,
};

export const getModuleDefaultProps = (type) => {
    const moduleConfig = MODULE_TYPES[type];
    return moduleConfig ? { ...moduleConfig.defaultProps } : {};
};

export const getModuleConfig = (type) => {
    return MODULE_TYPES[type] || null;
};